import { BaseInput } from './base-input';

export class FileInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
